export default __webpack_public_path__ + "static/media/parc1.baa484fc.png";